import capitalize from 'lodash/capitalize';

export const setPageTitle = (model, id, ref, date) => {
  let title = 'Finvisor |';
  if (!id) {
    title = `${title} New ${model} ...`;
  } else {
    title = `${title} ${model} ${ref}`;
    if (date) {
      title = `${title} from ${date}`;
    }
  }

  document.title = title;
};

export const urlResource = (path) => {
  const resource = path.split('/')[1]; // eslint-disable-line no-magic-numbers

  if (resource === '') {
    return 'dashboard';
  }

  return resource;
};

// Pages whose name is not their path's. `dax_info` is the DAX Data page
// (FIN-1357): the ship's Master Account and its Position list, both as DAX
// states them. Underscores, as the header turns them into spaces.
const PAGE_TITLES = {
  dax_info: 'DAX_Data',
};

export default (path) => {
  const resource = urlResource(path);
  return PAGE_TITLES[resource] || capitalize(resource);
};

// Pages that wear another product's brand in the header (FIN-1357): DAX Data
// is DAX's own statement, shown in DAX's colours under DAX's mark.
const PAGE_BRANDS = {
  dax_info: 'dax',
};

export const brandFromUrl = (path) => PAGE_BRANDS[urlResource(path)] || null;
